/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type BrnoDocsSignPartialUpdateRequest = {} | null | undefined;
export type BrnoDocsSignPartialUpdateResponse = any;

export type BrnoDocsSignPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/brno_docs/{id}/sign/
 *
 * ```yaml
 * operationId: brno_docs_sign_partial_update
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - brno_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const brnoDocsSignPartialUpdateOperation = ({
  id,
  ...rest
}: BrnoDocsSignPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/brno_docs/${id}/sign/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/brno_docs/{id}/sign/' };
  };

/**
 * PATCH /dmx-server/brno_docs/{id}/sign/
 *
 * ```yaml
 * operationId: brno_docs_sign_partial_update
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - brno_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const brnoDocsSignPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: BrnoDocsSignPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = brnoDocsSignPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
